import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import BenchmarkChip from '../BenchmarkChip';

import { ScoreRangeMeta } from '../../../../shared/types/widget';
import { useFilterData } from '../../../../utilities/hooks/useFilterData';
import useFilters from '../../../../utilities/hooks/useFilters';
import { IndustryAverageMetrics } from '../../../../shared/types/filters';
import { getAllBenchmarkDetails } from '../../../../utilities/common/utils';
import { SelectedBenchmark } from '../../../../shared/constants/filter/filter';
import { Typography } from '../../../widgets/Typography';

interface BenchmarkRangeProps {
  meta: ScoreRangeMeta;
  className?: string;
}

function BenchmarkRange({ meta, className }: BenchmarkRangeProps) {
  const { configData } = useFilterData();
  const { benchmarkType } = useFilters();
  const { t } = useTranslation();

  const scoreRanges = meta?.scoreRanges ?? [];
  const dimension = meta?.dimension as keyof IndustryAverageMetrics;

  const { global } = getAllBenchmarkDetails(meta, benchmarkType, configData!);

  return (
    <div className={twMerge('flex flex-row flex-wrap gap-6', className)}>
      {scoreRanges.map(({ label, color, min, max }) => (
        <div className="flex flex-row items-center gap-2" key={label}>
          <div
            aria-hidden="true"
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: color }}
          />
          <Typography
            variant="body-sm"
            weight="medium"
            className="text-grey-800"
          >
            {label}: {min} - {max}
          </Typography>
        </div>
      ))}

      {/* Render global average only dimension key exists */}
      {dimension && (
        <div className="flex flex-row items-center gap-2" key="benchmark">
          <div
            aria-hidden="true"
            className="bg-grey-600 h-2 w-2 shrink-0 rounded-full"
          />
          <Typography
            variant="body-sm"
            weight="medium"
            className="text-grey-800"
          >
            {`${t(
              benchmarkType === SelectedBenchmark.GLOBAL
                ? 'GLOBAL'
                : 'INDUSTRY',
            )} ${t('AVERAGE')}: ${global.value}`}
          </Typography>
        </div>
      )}
    </div>
  );
}

export default BenchmarkRange;
